export default __webpack_public_path__ + "static/media/H4008.c07ab1d3.mp3";